// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"9785":"css/app.6950","9805":"css/admin-app.6950"}[chunkId] + ".css";
};